import React from "react";

import Box from "@/components/shared/Box";
import Avatar from "@/components/shared/Avatar";

import type { PhysicalCharacteristicProps } from "./physicalCharacteristic.types";

import s from "./physicalCharacteristic.module.scss";

import {
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  fa7,
  fa8,
  fa9
} from "@fortawesome/pro-solid-svg-icons";

const iconsList = [fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9];

const PhyschicalCharacteristic = ({
  caracteristicasFisicas,
  imagemCaracteristicasFisicas
}: PhysicalCharacteristicProps) => {
  return (
    <div className={s.wrapper}>
      <h2 className={`heading-sm ${s.title}`}>Características físicas</h2>
      <Box
        padding={"var(--token-spacings-xxs)"}
        border={"1px solid var(--token-colors-neutral-cloud-normal)"}
        borderRadius={"var(--token-border-radius-lg)"}
      >
        <div className={s.content}>
          {imagemCaracteristicasFisicas && (
            <div>
              <img
                src={imagemCaracteristicasFisicas}
                alt="caracteristicas fisicas"
                width={252}
                height={252}
              />
            </div>
          )}
          <div className={s.descriptions}>
            {caracteristicasFisicas.slice(0, 9).map((item, index) => {
              const icon = iconsList[index % iconsList.length];
              return (
                <div key={index} className={s.description}>
                  <Avatar
                    pill="top-start"
                    icon={icon}
                    iconProps={{
                      color: "var(--token-cobasi-colors-turquoise-primary)"
                    }}
                  />
                  <div className={s.text}>
                    <h3 className="subtitle-sm">{item.title}</h3>
                    <p className="body-text-sm">{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Box>
    </div>
  );
};

export default PhyschicalCharacteristic;
